// maybe you want to use enumKeys(FontWeight) instead.
import { Option } from '../types';

export enum DjangoFontWeight {
    'Variable' = null,
    'Hairline' = 100,
    'Extra Thin' = 125,
    'Thin' = 150,
    'Extra Light' = 200,
    'XLight' = 250,
    'Light' = 300,
    'Semi Light' = 350,
    'Book' = 390,
    'Regular' = 400,
    'Standard' = 450,
    'Medium' = 500,
    'Semi Bold' = 600,
    'Bold' = 700,
    'Extra Bold' = 750,
    'Heavy' = 775,
    'Black' = 800,
    'Extra Black' = 850,
    'Ultra' = 875,
    'Ultra Black' = 900,
}

export const FONT_WEIGHTS = [
    100,
    125,
    150,
    200,
    250,
    300,
    350,
    390,
    400,
    450,
    500,
    600,
    700,
    750,
    775,
    800,
    850,
    875,
    900,
    'variable',
] as const;

export type FontWeight = (typeof FONT_WEIGHTS)[number];

export function isFontWeight(value: unknown): value is FontWeight {
    return FONT_WEIGHTS.includes(value as FontWeight);
}

export const FONT_WEIGHT_OPTIONS: Option<FontWeight>[] = [
    { value: 'variable', label: 'Variable' },
    { value: 100, label: 'Hairline' },
    { value: 125, label: 'Extra Thin' },
    { value: 150, label: 'Thin' },
    { value: 200, label: 'Extra Light' },
    { value: 250, label: 'XLight' },
    { value: 300, label: 'Light' },
    { value: 350, label: 'Semi Light' },
    { value: 390, label: 'Book' },
    { value: 400, label: 'Regular' },
    { value: 450, label: 'Standard' },
    { value: 500, label: 'Medium' },
    { value: 600, label: 'Semi Bold' },
    { value: 700, label: 'Bold' },
    { value: 750, label: 'Extra Bold' },
    { value: 775, label: 'Heavy' },
    { value: 800, label: 'Black' },
    { value: 850, label: 'Extra Black' },
    { value: 875, label: 'Ultra' },
    { value: 900, label: 'Ultra Black' },
] as const;
